import React from "react";
import emailjs from "emailjs-com";
import { Col, Container, Form, Row } from "react-bootstrap";
import { FaGithub, FaLinkedinIn, FaMediumM } from "react-icons/fa";
import { HiOutlineMail } from "react-icons/hi";
import { profile } from "../data/portfolio";
import "./Contact.css";

const Contact = () => {
  const onSubmitHandler = (e) => {
    e.preventDefault();

    emailjs
      .sendForm(
        process.env.REACT_APP_EMAIL_ID,
        process.env.REACT_APP_EMAIL_TEMPLATE,
        e.target,
        process.env.REACT_APP_EMAIL_USERID
      )
      .then(
        () => {
          alert("Your message has been sent successfully.");
        },
        (error) => {
          alert("Message sending failed. Please email me directly.");
          console.log(error.text);
        }
      );
    e.target.reset();
  };

  return (
    <Container fluid className="contact-section section-shell">
      <Container>
        <Row className="g-5 align-items-start">
          <Col lg={5} className="scroll-reveal">
            <div className="section-kicker">Contact</div>
            <h1 className="section-title">Let's build something fast together.</h1>
            <p className="section-copy">
              I'm open to frontend, React Native, and product engineering roles — anywhere quality of execution and
              measurable outcomes matter. Tell me what you're building and I'll get back to you quickly.
            </p>

            <div className="contact-links">
              <a href={`mailto:${profile.email}`} className="scroll-reveal">
                <HiOutlineMail /> {profile.email}
              </a>
              <a href={profile.linkedin} target="_blank" rel="noreferrer" className="scroll-reveal">
                <FaLinkedinIn /> LinkedIn
              </a>
              <a href={profile.github} target="_blank" rel="noreferrer" className="scroll-reveal">
                <FaGithub /> GitHub
              </a>
              <a href={profile.medium} target="_blank" rel="noreferrer" className="scroll-reveal">
                <FaMediumM /> Medium
              </a>
            </div>
          </Col>

          <Col lg={7}>
            <Form className="contact-form glass-panel scroll-reveal" onSubmit={onSubmitHandler}>
              <Row className="g-3">
                <Col md={6}>
                  <Form.Group controlId="formGridName">
                    <Form.Label>Name</Form.Label>
                    <Form.Control type="text" placeholder="Your name" name="name" required />
                  </Form.Group>
                </Col>
                <Col md={6}>
                  <Form.Group controlId="formGridEmail">
                    <Form.Label>Email</Form.Label>
                    <Form.Control type="email" placeholder="you@example.com" name="email" required />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group controlId="formGridSubject">
                    <Form.Label>Subject</Form.Label>
                    <Form.Control type="text" placeholder="Role, project, or collaboration" name="subject" required />
                  </Form.Group>
                </Col>
                <Col md={12}>
                  <Form.Group controlId="exampleFormMessage">
                    <Form.Label>Message</Form.Label>
                    <Form.Control as="textarea" rows="5" placeholder="Tell me what you are building." name="message" required />
                  </Form.Group>
                </Col>
              </Row>
              <button className="bt-submit" type="submit" value="send">
                Send message
              </button>
            </Form>
          </Col>
        </Row>
      </Container>
    </Container>
  );
};

export default Contact;
